/**
 * normalizeAircards
 *
 * Normalizes the aircard values stored in the AircardForm.Provision aircard forms for use with API methods
 */
export default aircardValues =>
  Object.entries(aircardValues)
    .filter(([key, value]) => !!key && !!value)
    .reduce((acc, [type, aircardArray]) => {
      const mappedAircards = aircardArray
        .filter(aircard => !!aircard)
        .map(fields => ({ type, ...fields }));
      return [...acc, ...mappedAircards];
    }, []);
